import { Component, computed, EventEmitter, input, Output } from '@angular/core';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import { PdfJob } from 'src/app/models/pdf-job.interface';
dayjs.locale('de');

/**
 * Component for listing pdf jobs in the navigation bar downloads popup.
 */
@Component({
    selector: 'app-pdf-jobs',
    templateUrl: './pdf-jobs.component.html',
    styleUrls: ['./pdf-jobs.component.scss'],
    standalone: false,
})
export class PdfJobsComponent {
    /**
     * The pdf jobs to show in the list.
     */
    pdfJobs = input.required<PdfJob[]>();

    /**
     * Emitted when a pdf job is deleted
     */
    @Output() delete = new EventEmitter<PdfJob & { isOld?: boolean }>();
    /**
     * Emitted when a pdf is downloaded
     */
    @Output() download = new EventEmitter<PdfJob & { isOld?: boolean }>();

    jobsByDay = computed(() => {
        const byDay = new Map<string, PdfJob[]>();

        for (const job of this.pdfJobs()) {
            let day = dayjs(job.createdAt).format('DD MMMM YYYY');
            if (dayjs().isSame(dayjs(job.createdAt), 'date')) {
                day = 'Heute';
            }

            const dayJobs = byDay.get(day) ?? [];
            dayJobs.push(job);
            byDay.set(day, dayJobs);
        }
        return byDay;
    });

    jobsByDayEntries = computed(() => Array.from(this.jobsByDay().entries()));
}
